export function getStayId(stayEvent) {
  if (stayEvent.object) {
    return stayEvent.object.id;
  }
  return stayEvent.stay.id;
}
